import { StyleSheet, TextProps, View } from "react-native";
import { animDuration, colors, invariantColor, radii } from "../utils/design";
import { Icon } from "./Icon";
import { Space } from "./Space";
import { PressableLink, Text } from "./Text";

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: colors.neutral[800],
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderRadius: radii[4],
    outlineWidth: 0,
    borderWidth: 1,
    borderColor: colors.neutral[700],
    transitionDuration: animDuration[200],
    transitionProperty: "background-color, border-color",
  },
  containerHovered: {
    borderColor: colors.neutral[200],
  },
  containerPressed: {
    backgroundColor: colors.neutral[700],
    borderColor: colors.neutral[200],
  },

  fill: {
    flex: 1,
  },
});

type Props = {
  to: string;
  avatar: React.ReactElement;
  title: React.ReactNode;
  description?: string;
  disabled?: boolean;
  style?: TextProps["style"];
};

export const RowLink: React.FC<Props> = ({
  to,
  avatar,
  title,
  description,
  disabled = false,
  style,
}) => {
  return (
    <PressableLink
      to={to}
      disabled={disabled}
      style={({ focused, hovered, pressed }) => [
        styles.container,
        (focused || hovered) && styles.containerHovered,
        pressed && styles.containerPressed,
        style,
      ]}
    >
      {avatar}

      <Space width={12} />

      <View style={styles.fill}>
        <Text variant="small" color={invariantColor.white} style={{ alignItems: "center" }}>
          {title}
        </Text>
        <Text variant="small">{description}</Text>
      </View>

      {!disabled && (
        <>
          <Space width={12} />
          <Icon name="chevron_right" color={colors.neutral[600]} />
        </>
      )}
    </PressableLink>
  );
};
